export default "__VITE_ASSET__DP1K6B$G__"